import { Card, CardBody } from '@vnetwork/ui/primitives';
import { Stat } from '@vnetwork/ui/data';
import { useTicketCounts, type TicketStatus } from '@/api/support';
import styles from './TicketStatBand.module.css';

interface StatCard {
  status: TicketStatus | '';
  label: string;
}

// Headline statuses surfaced as clickable filter cards.
const CARDS: StatCard[] = [
  { status: '', label: 'All tickets' },
  { status: 'opening', label: 'Open' },
  { status: 'work-in-progress', label: 'In progress' },
  { status: 'pending', label: 'Pending' },
  { status: 'completed', label: 'Resolved' },
];

interface TicketStatBandProps {
  active: TicketStatus | '';
  onSelect: (status: TicketStatus | '') => void;
}

/** A row of clickable DS Card flat tiles that double as the status filter. */
export function TicketStatBand({ active, onSelect }: TicketStatBandProps) {
  const counts = useTicketCounts(CARDS.map((c) => c.status));

  return (
    <div className={styles.band}>
      {CARDS.map((card, i) => {
        const isActive = active === card.status;
        const q = counts[i];
        return (
          <Card
            key={card.status || 'all'}
            flat
            role="button"
            tabIndex={0}
            aria-pressed={isActive}
            className={isActive ? `${styles.tile} ${styles.tileActive}` : styles.tile}
            onClick={() => onSelect(card.status)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect(card.status);
              }
            }}
          >
            <CardBody>
              <Stat
                label={card.label}
                value={q?.isLoading ? '—' : q?.isError ? '—' : String(q?.data ?? 0)}
              />
            </CardBody>
          </Card>
        );
      })}
    </div>
  );
}
